import { useContext } from "react";
import SelectedIndexSetTemplateContext from "components/indices/IndexSetTemplates/contexts/SelectedIndexSetTemplateContext";
const useSelectedTemplate = () => {
  const contextValue = useContext(SelectedIndexSetTemplateContext);
  if (!contextValue) {
    throw new Error("useSelectedTemplate hook needs to be used inside SelectedIndexSetTemplateContext.Provider");
  }
  return contextValue;
};
export default useSelectedTemplate;
